// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_24-1";
export var movingGradient = "_24-4";
export var movingGradientBlock = "_24-2";
export var skeleton = "_24-0";
export var skeletonText = "_24-3";